module.exports = __webpack_public_path__ + "static/img/1-2.11db435.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/1-2.png
// module id = G9Sj
// module chunks = 0